import {
  CreateOrderReportPayload,
  CreateReportPayload,
  Report,
} from "@web-app/types";
import http from "@web-app/utils/http";

export const createReport = async (
  orderId: string,
  payload: CreateReportPayload,
): Promise<Report> => {
  return http
    .post(`/tracking/orders/${orderId}/reports`, payload)
    .then((response) => response.data);
};

export const createOrderReport = async (
  orderId: string,
  payload: CreateOrderReportPayload,
): Promise<Report> => {
  return http
    .post(`/orders/${orderId}/reports`, payload)
    .then((response) => response.data);
};

export const getReportsByOrderId = async (
  orderId: string,
): Promise<Report[]> => {
  return http
    .get(`/tracking/orders/${orderId}/reports`)
    .then((response) => response.data);
};

export const getReportsByOrderIds = async (
  orderIds: string[],
): Promise<Record<string, Report[]>> => {
  return http
    .post("/reports/batch", { orderIds })
    .then((response) => response.data);
};

export const updateReportResolution = async (
  reportId: string,
  resolved: boolean,
): Promise<Report> => {
  return http
    .patch(`/reports/${reportId}`, { resolved })
    .then((response) => response.data);
};
